import { render, staticRenderFns } from "./SkinsList.vue?vue&type=template&id=418a595f&scoped=true&"
import script from "./SkinsList.vue?vue&type=script&lang=js&"
export * from "./SkinsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418a595f",
  null
  
)

export default component.exports